import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-5"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "walkthrough-section"
};
const _hoisted_4 = {
    key: 1,
    class: "walkthrough-section"
};
const _hoisted_5 = { class: "category-grid" };
const _hoisted_6 = { class: "group-label" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "doc-info" };
const _hoisted_9 = { class: "doc-company" };
const _hoisted_10 = { class: "doc-filename" };
const _hoisted_11 = { class: "doc-added" };
const _hoisted_12 = {
    key: 0,
    class: "doc-label"
};
const _hoisted_13 = ["src"];
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useDocuments } from '@/composables/useDocuments';
import { useContent } from '@/composables/useContent';
import { useWhatsApp } from '@/composables/useWhatsApp';
import HeaderBlock from './elements/HeaderBlock.vue';
import AccountTypeFilter from './elements/AccountTypeFilter.vue';
import DocCategoryCard from './elements/DocCategoryCard.vue';
import AiChatBanner from './elements/AiChatBanner.vue';
import RecentDocuments from './elements/RecentDocuments.vue';
import FaqsSection from './FaqsSection.vue';
import WhatsAppPromoCard from './elements/WhatsAppPromoCard.vue';
import WhatsAppEnableDrawer from './elements/WhatsAppEnableDrawer.vue';
import MGWalkthrough from './elements/MGWalkthrough.vue';
import DocumentTypeGrid from './elements/DocumentTypeGrid.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getDocuments, getDocumentTypes } = useDocuments();
        const { getWalkthrough, getFaqs: getContentFaqs } = useContent();
        const instance = getCurrentInstance();
        const whatsAppNumber = instance?.appContext.config.globalProperties.$whatsAppNumber || '';
        const whatsAppPromoCard = ref(null);
        const whatsAppEnableDrawer = ref(null);
        const { handleWhatsAppAction, handleEnableWhatsApp, handleWhatsAppEnableDone, handleWhatsAppDrawerClosed } = useWhatsApp({
            whatsAppPromoCard,
            whatsAppEnableDrawer,
            whatsAppNumber,
        });
        const activeTab = ref('all');
        const documentTypes = ref(null);
        const faqs = ref([]);
        const heroWalkthroughData = ref(null);
        let _leavingForDoc = false;
        const documentCategoryImageMap = {
            'Home': require('@/assets/doc-categories/home.png'),
            'Family': require('@/assets/doc-categories/family.png'),
            'Banking': require('@/assets/doc-categories/banking.png'),
            'Investments': require('@/assets/doc-categories/investments.png'),
            'Vehicles': require('@/assets/doc-categories/vehicle.png'),
            'Travel': require('@/assets/doc-categories/travel.png'),
            'Work': require('@/assets/doc-categories/work.png'),
            'Tax': require('@/assets/doc-categories/tax.png'),
            'Health': require('@/assets/doc-categories/health.png'),
            'Subscriptions': require('@/assets/doc-categories/subscriptions.png'),
            'Personal': require('@/assets/doc-categories/personal.png'),
            'Pets': require('@/assets/doc-categories/pets.png'),
            'Important': require('@/assets/doc-categories/important.png'),
        };
        const defaultCategoryImage = require('@/assets/doc-categories/other.png');
        function getDocumentCategoryImage(category) {
            return documentCategoryImageMap[category] || defaultCategoryImage;
        }
        const hasDocuments = computed(() => {
            return state.documents && state.documents.length > 0;
        });
        const filterTabs = computed(() => {
            const tabs = [{ value: 'all', label: 'All' }];
            if (documentTypes.value) {
                const seen = new Set();
                const categories = [];
                documentTypes.value.forEach((t) => {
                    const category = t.path?.split(' > ')[1];
                    if (category && !seen.has(category)) {
                        seen.add(category);
                        categories.push(category);
                    }
                });
                const counts = categoryCounts.value;
                categories.sort((a, b) => (counts[b] || 0) - (counts[a] || 0) || a.localeCompare(b));
                categories.forEach(c => tabs.push({ value: c, label: c }));
            }
            return tabs;
        });
        const categoryCards = computed(() => {
            const counts = categoryCounts.value;
            const categories = filterTabs.value.filter(t => t.value !== 'all').map(t => t.value);
            const withDocs = categories.filter(name => counts[name]).sort((a, b) => counts[b] - counts[a] || a.localeCompare(b));
            const withoutDocs = categories.filter(name => !counts[name]);
            return [...withDocs, ...withoutDocs].map(name => ({
                label: name, tabValue: name, illustration: getDocumentCategoryImage(name)
            }));
        });
        const categoryCounts = computed(() => {
            if (!state.documents)
                return {};
            const counts = {};
            state.documents.forEach((doc) => {
                const category = getDocCategory(doc);
                counts[category] = (counts[category] || 0) + 1;
            });
            return counts;
        });
        const groupedDocuments = computed(() => {
            if (!state.documents)
                return [];
            const filtered = state.documents.filter((doc) => {
                const category = getDocCategory(doc);
                return category === activeTab.value;
            });
            const sorted = filtered.sort((a, b) => new Date(b.createDateTime).getTime() - new Date(a.createDateTime).getTime());
            const groups = [];
            const map = {};
            sorted.forEach((doc) => {
                const label = getDocGroupLabel(doc);
                if (!map[label]) {
                    map[label] = { label, docs: [] };
                    groups.push(map[label]);
                }
                map[label].docs.push(doc);
            });
            return groups;
        });
        watch(activeTab, (newVal) => {
            if (newVal === 'all') {
                sessionStorage.removeItem('docs-filter-tab');
            }
            else {
                sessionStorage.setItem('docs-filter-tab', newVal);
            }
        });
        function getDocPathParts(doc) {
            const path = doc.sysoDocumentType?.path;
            if (!path)
                return null;
            return path.split(' > ');
        }
        function getDocCategory(doc) {
            const parts = getDocPathParts(doc);
            if (!parts || parts.length < 2)
                return 'Other';
            return parts[1];
        }
        function getDocGroupLabel(doc) {
            const parts = getDocPathParts(doc);
            return parts && parts.length >= 3 ? parts[2] : doc.sysoDocumentType?.name || doc.documentType || 'Other';
        }
        function properCase(str) {
            if (!str)
                return '';
            return str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
        }
        function openDoc(id) {
            _leavingForDoc = true;
            router.push('/documents/' + id);
        }
        function onHeaderWhatsApp() {
            activeTab.value = 'all';
            nextTick(() => {
                if (whatsAppPromoCard.value?.$el) {
                    whatsAppPromoCard.value.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                handleWhatsAppAction();
            });
        }
        function onLoad() {
            getCustomer(() => {
                getDocuments(() => { });
            });
            getDocumentTypes((types) => {
                documentTypes.value = types;
            });
            getContentFaqs('document-faqs', (result) => {
                faqs.value = result?.faqItems || [];
            });
            getWalkthrough('document-hero', (result) => {
                heroWalkthroughData.value = result;
            });
        }
        onMounted(() => {
            const saved = sessionStorage.getItem('docs-filter-tab');
            if (saved)
                activeTab.value = saved;
            onLoad();
        });
        onBeforeUnmount(() => {
            if (!_leavingForDoc) {
                sessionStorage.removeItem('docs-filter-tab');
            }
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "My Documents",
                    logicalBack: activeTab.value !== 'all',
                    onLogicalBack: _cache[0] || (_cache[0] = ($event) => (activeTab.value = 'all')),
                    onWhatsapp: onHeaderWhatsApp
                }, null, 8, ["logicalBack"]),
                (!(_unref(state).customer && _unref(state).documents))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_skeleton_loader, {
                            width: "100%",
                            type: "paragraph",
                            class: "mb-4"
                        }),
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                            width: "100%",
                                            type: "card"
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                            width: "100%",
                                            type: "card"
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                            width: "100%",
                                            type: "card"
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                            width: "100%",
                                            type: "card"
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                            width: "100%",
                                            type: "card"
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                            width: "100%",
                                            type: "card"
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).documents)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(AiChatBanner),
                                (!hasDocuments.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (!heroWalkthroughData.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    type: "card",
                                                    height: "240px"
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        (heroWalkthroughData.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createVNode(MGWalkthrough, {
                                                    walkthroughData: heroWalkthroughData.value,
                                                    variant: "sheet",
                                                    compact: true,
                                                    dotsAbove: false,
                                                    imageHeight: '220',
                                                    height: "240px",
                                                    onActionClicked: _unref(handleWhatsAppAction)
                                                }, null, 8, ["walkthroughData", "onActionClicked"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "what-can-add-heading" }, "What can I add?", -1)),
                                        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "what-can-add-subtext" }, "Send documents via WhatsApp and we'll organise them for you", -1)),
                                        _createVNode(DocumentTypeGrid, { class: "document-type-grid-section" }),
                                        (faqs.value.length)
                                            ? (_openBlock(), _createBlock(FaqsSection, {
                                                key: 2,
                                                class: "faq-section",
                                                faqs: faqs.value,
                                                limit: 5,
                                                faqName: "document-faqs"
                                            }, null, 8, ["faqs"]))
                                            : _createCommentVNode("", true),
                                        _createVNode(WhatsAppPromoCard, {
                                            class: "whatsapp-promo",
                                            ref_key: "whatsAppPromoCard",
                                            ref: whatsAppPromoCard,
                                            showImage: true,
                                            closable: false,
                                            title: "Send a document or photo",
                                            subtitle: "We'll add the key details and save the document securely. You can also chat with your WhatsApp assistant about this policy.",
                                            onAction: _unref(handleWhatsAppAction)
                                        }, null, 8, ["onAction"])
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createVNode(AccountTypeFilter, {
                                            tabs: filterTabs.value,
                                            modelValue: activeTab.value,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((activeTab).value = $event))
                                        }, null, 8, ["tabs", "modelValue"]),
                                        (activeTab.value === 'all')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("div", _hoisted_5, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryCards.value, (card) => {
                                                        return (_openBlock(), _createBlock(DocCategoryCard, {
                                                            key: card.tabValue,
                                                            label: card.label,
                                                            illustration: card.illustration,
                                                            count: categoryCounts.value[card.tabValue] ? categoryCounts.value[card.tabValue] + ' documents' : null,
                                                            onClick: ($event) => (activeTab.value = card.tabValue)
                                                        }, null, 8, ["label", "illustration", "count", "onClick"]));
                                                    }), 128))
                                                ]),
                                                _createVNode(RecentDocuments, {
                                                    documents: _unref(state).documents,
                                                    limit: 3,
                                                    onDocClick: _cache[2] || (_cache[2] = (doc) => openDoc(doc.id)),
                                                    onViewMore: _cache[3] || (_cache[3] = ($event) => (_unref(router).push('/AllDocuments')))
                                                }, null, 8, ["documents"]),
                                                (faqs.value.length)
                                                    ? (_openBlock(), _createBlock(FaqsSection, {
                                                        key: 0,
                                                        class: "faq-section",
                                                        faqs: faqs.value,
                                                        limit: 5,
                                                        faqName: "document-faqs"
                                                    }, null, 8, ["faqs"]))
                                                    : _createCommentVNode("", true),
                                                _createVNode(WhatsAppPromoCard, {
                                                    class: "whatsapp-promo",
                                                    ref_key: "whatsAppPromoCard",
                                                    ref: whatsAppPromoCard,
                                                    showImage: true,
                                                    closable: false,
                                                    title: "Send a document or photo",
                                                    subtitle: "We'll add the key details and save the document securely. You can also chat with your WhatsApp assistant about this policy.",
                                                    onAction: _unref(handleWhatsAppAction)
                                                }, null, 8, ["onAction"])
                                            ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (groupedDocuments.value.length === 0)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "no-filtered-docs" }, [
                                                            _createElementVNode("p", { class: "no-filtered-docs-title" }, "No documents here yet."),
                                                            _createElementVNode("p", { class: "no-filtered-docs-subtitle" }, "Send one and we'll file it here automatically.")
                                                        ], -1)),
                                                        (faqs.value.length)
                                                            ? (_openBlock(), _createBlock(FaqsSection, {
                                                                key: 0,
                                                                class: "faq-section",
                                                                faqs: faqs.value,
                                                                limit: 5,
                                                                faqName: "document-faqs"
                                                            }, null, 8, ["faqs"]))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(WhatsAppPromoCard, {
                                                            class: "whatsapp-promo",
                                                            ref_key: "whatsAppPromoCard",
                                                            ref: whatsAppPromoCard,
                                                            showImage: true,
                                                            closable: false,
                                                            title: "Send a document or photo",
                                                            subtitle: "We'll add the key details and save the document securely. You can also chat with your WhatsApp assistant about this policy.",
                                                            onAction: _unref(handleWhatsAppAction)
                                                        }, null, 8, ["onAction"])
                                                    ], 64))
                                                    : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedDocuments.value, (group) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: group.label,
                                                        class: "doc-type-group"
                                                    }, [
                                                        _createElementVNode("p", _hoisted_6, _toDisplayString(group.label), 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.docs, (doc) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: doc.id,
                                                                class: "doc-row",
                                                                onClick: ($event) => (openDoc(doc.id))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_8, [
                                                                    _createElementVNode("p", _hoisted_9, _toDisplayString(properCase(doc.company || doc.documentSubject)), 1),
                                                                    _createElementVNode("p", _hoisted_10, _toDisplayString(doc.documentName), 1),
                                                                    _createElementVNode("p", _hoisted_11, "Added " + _toDisplayString(doc.createDateTimeString), 1),
                                                                    (doc.documentSubject)
                                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(doc.documentSubject), 1))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _createElementVNode("img", {
                                                                    src: require('@/assets/arrow-right.png'),
                                                                    class: "doc-arrow"
                                                                }, null, 8, _hoisted_13)
                                                            ], 8, _hoisted_7));
                                                        }), 128))
                                                    ]));
                                                }), 128))
                                            ], 64))
                                    ], 64)),
                                _cache[7] || (_cache[7] = _createElementVNode("div", { style: { "clear": "both", "padding-bottom": "110px" } }, null, -1))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(WhatsAppEnableDrawer, {
                    ref_key: "whatsAppEnableDrawer",
                    ref: whatsAppEnableDrawer,
                    phoneNumber: _unref(state).customer?.person?.mobilePhone || '',
                    onEnable: _unref(handleEnableWhatsApp),
                    onDone: _unref(handleWhatsAppEnableDone),
                    onClosed: _unref(handleWhatsAppDrawerClosed)
                }, null, 8, ["phoneNumber", "onEnable", "onDone", "onClosed"])
            ], 64));
        };
    }
});
